import { Checkbox } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { select, unselect } from '../../actions/selected';
import { selectIsEntitySelected } from '../../selectors/selected';
import { IFavoriteEntity } from '../../types/results';

interface IProps {
  favoriteEntity: IFavoriteEntity;
}

export const CheckboxContainer: React.FC<IProps> = ({ favoriteEntity }) => {
  const { entityId, entityType, fullUrl } = favoriteEntity;
  const isChecked = useSelector(selectIsEntitySelected(entityId, entityType));
  const dispatch = useDispatch();
  const onChange = () =>
    dispatch(isChecked ? unselect({ entityId, entityType }) : select({ entityId, entityType, fullUrl }));

  return <Checkbox checked={isChecked} onChange={onChange} />;
};
